import network from '../services/Network'
import browser from './browser'
import { store } from '../store'
import { emit } from './Controller'

const HEARTBEAT_INTERVAL = 1000 * 20 // 20 SEC
const CAFFEINATE_INTERVAL = 1000 // 1 SEC

class Heartbeat {
  count = 0
  restInterval?: number = undefined
  caffeineInterval?: number = undefined
  checkAll?: true = undefined

  init() {
    if (browser.hasBackend) {
      window.onfocus = this.start
      window.onblur = this.stop
      network.on('connect', this.start)
      network.on('disconnect', this.stop)
      if (document.hasFocus()) this.start()
    }
  }

  start = () => {
    if (network.isActive() && !this.restInterval) {
      this.restInterval = window.setInterval(this.beat, HEARTBEAT_INTERVAL)
      this.beat()
    }
  }

  stop = () => {
    if (this.restInterval) {
      window.clearInterval(this.restInterval)
      this.restInterval = undefined
    }
  }

  beat = () => {
    const { auth } = store.getState()
    if (navigator.onLine && auth.backendAuthenticated) {
      emit('heartbeat', this.checkAll)
    }
  }

  connect = () => {
    this.caffeinate(12)
  }

  disconnect = () => {
    setTimeout(() => this.caffeinate(6), 2000)
  }

  caffeinate = (count: number) => {
    this.count = 0
    console.log('START CAFFEINATE')
    if (this.caffeineInterval) window.clearInterval(this.caffeineInterval)
    this.caffeineInterval = window.setInterval(() => {
      if (this.count++ > count) {
        window.clearInterval(this.caffeineInterval)
        this.caffeineInterval = undefined
      }
      this.beat()
    }, CAFFEINATE_INTERVAL)
  }
}

export default new Heartbeat()
